"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NiftronXDRType = void 0;
/**
 * Niftron XDR Type Interface
 */

var NiftronXDRType;

(function (NiftronXDRType) {
  NiftronXDRType["MINT_ART"] = "MINT0000001";
  NiftronXDRType["MINT_TICKET"] = "MINT0000002";
  NiftronXDRType["MINT_DOMAIN"] = "MINT0000003";
  NiftronXDRType["MINT_CERTIFICATE"] = "MINT0000004";
  NiftronXDRType["TRANSFER_ART"] = "TRAN0000001";
  NiftronXDRType["TRANSFER_TICKET"] = "TRAN0000002";
  NiftronXDRType["TRANSFER_DOMAIN"] = "TRAN0000003";
  NiftronXDRType["TRANSFER_CERTIFICATE"] = "TRAN0000004";
  NiftronXDRType["PROOF_OF_SIGNATURE"] = "PROOF0000001";
  NiftronXDRType["ADD_DATA"] = "DATA0000001";
  NiftronXDRType["AUTH_LOGIN"] = "AUTH0000001";
})(NiftronXDRType = exports.NiftronXDRType || (exports.NiftronXDRType = {}));